const CHAIN_SLUG = {
  Ethereum:  "ethereum",
  Arbitrum:  "arbitrum",
  Optimism:  "optimism",
  Base:      "base",
  Polygon:   "polygon",
  Avalanche: "avalanche",
  BSC:       "bsc",
  Solana:    "solana",
};

const UNISWAP_CHAIN = {
  Ethereum:  "mainnet",
  Arbitrum:  "arbitrum",
  Optimism:  "optimism",
  Base:      "base",
  Polygon:   "polygon",
  Avalanche: "avalanche",
};

// Direct link to add liquidity on the specific pool
export function getPoolUrl(pool) {
  const { protocol, chain } = pool;

  // Uniswap V3: create position page (new UI no longer uses token params in URL)
  if (protocol === "Uniswap V3") {
    const chainSlug = UNISWAP_CHAIN[chain] || "mainnet";
    return `https://app.uniswap.org/positions/create/v3?chain=${chainSlug}`;
  }

  // Curve: link to Curve main pools page (no contract address available from API)
  if (protocol === "Curve") {
    const chainSlug = CHAIN_SLUG[chain] || "ethereum";
    return `https://curve.fi/#/${chainSlug}/pools`;
  }

  // Balancer: link to Balancer pools page (no contract address available from API)
  if (protocol === "Balancer") {
    const chainSlug = CHAIN_SLUG[chain] || "ethereum";
    return `https://app.balancer.fi/#/${chainSlug}/pools`;
  }

  // PancakeSwap: generic pools page (safe format, always works)
  if (protocol === "PancakeSwap") {
    return `https://pancakeswap.finance/liquidity/pools`;
  }

  // Raydium: pools page (no contract address available from API)
  if (protocol === "Raydium") {
    return `https://raydium.io/liquidity-pools/`;
  }

  // Orca: pools page (no contract address available from API)
  if (protocol === "Orca") {
    return `https://www.orca.so/pools`;
  }

  // Kamino: liquidity page (no contract address available from API)
  if (protocol === "Kamino") {
    return `https://app.kamino.finance/liquidity`;
  }

  // Uniswap V4: create position page (new UI format)
  if (protocol === "Uniswap V4") {
    const chainSlug = UNISWAP_CHAIN[chain] || "mainnet";
    return `https://app.uniswap.org/positions/create/v4?chain=${chainSlug}`;
  }

  // Aerodrome: generic pools page (always works)
  if (protocol === "Aerodrome") {
    return `https://aerodrome.finance/pools`;
  }

  // Velodrome: generic pools page (always works)
  if (protocol === "Velodrome") {
    return `https://app.velodrome.finance/pools`;
  }

  // SushiSwap: generic pool page
  if (protocol === "SushiSwap") {
    return `https://www.sushi.com/pool`;
  }

  // Trader Joe: pools page (no contract address available from API)
  if (protocol === "Trader Joe") {
    const chainSlug = CHAIN_SLUG[chain] || "avalanche";
    return `https://traderjoexyz.com/${chainSlug}/pool`;
  }

  // Camelot: liquidity page
  if (protocol === "Camelot") {
    return `https://app.camelot.exchange/liquidity`;
  }

  // Last resort: DeFi Llama pool page
  if (pool.poolId) {
    return `https://defillama.com/yields/pool/${pool.poolId}`;
  }

  return null;
}

export function getSwapUrl(pool) {
  const { protocol, chain } = pool;

  // Uniswap V3: swap page with chain only (token params removed for reliability)
  if (protocol === "Uniswap V3") {
    const chainSlug = UNISWAP_CHAIN[chain] || "mainnet";
    return `https://app.uniswap.org/swap?chain=${chainSlug}`;
  }

  // Curve: swap page
  if (protocol === "Curve") {
    const chainSlug = chain === "Ethereum" ? "" : `/${CHAIN_SLUG[chain]}`;
    return `https://curve.fi${chainSlug}/#/swap`;
  }

  // Balancer: swap page
  if (protocol === "Balancer") {
    const chainSlug = CHAIN_SLUG[chain] || "ethereum";
    return `https://app.balancer.fi/#/${chainSlug}/swap`;
  }

  // PancakeSwap: generic swap page
  if (protocol === "PancakeSwap") {
    return `https://pancakeswap.finance/swap`;
  }

  // Raydium: swap page
  if (protocol === "Raydium") {
    return `https://raydium.io/swap/`;
  }

  // Orca: swap page
  if (protocol === "Orca") {
    return `https://www.orca.so/`;
  }

  // Kamino: swap via Jupiter
  if (protocol === "Kamino") {
    return `https://jup.ag/swap/`;
  }

  // Uniswap V4: swap page with chain only
  if (protocol === "Uniswap V4") {
    const chainSlug = UNISWAP_CHAIN[chain] || "mainnet";
    return `https://app.uniswap.org/swap?chain=${chainSlug}`;
  }

  // Aerodrome: generic swap page
  if (protocol === "Aerodrome") {
    return `https://aerodrome.finance/swap`;
  }

  // Velodrome: generic swap page
  if (protocol === "Velodrome") {
    return `https://app.velodrome.finance/swap`;
  }

  // SushiSwap: generic swap page
  if (protocol === "SushiSwap") {
    return `https://www.sushi.com/swap`;
  }

  // Trader Joe: swap page
  if (protocol === "Trader Joe") {
    const chainSlug = CHAIN_SLUG[chain] || "avalanche";
    return `https://traderjoexyz.com/${chainSlug}/trade`;
  }

  // Camelot: swap page
  if (protocol === "Camelot") {
    return `https://app.camelot.exchange/swap`;
  }

  return null;
}
